import type { ResetBtnType } from '@/src/Types/Shared/Button';
import { ArrowLong, ArrowSmall } from '@/src/Views/Shared/Icons';
import { __Front } from '@/src/Views/Shared/lib';

import { Animation } from './Animation';

export function ResetBtn(props: ResetBtnType) {
	return (
		<>
			{props.btnClassName?.btnStyle?.btnIsBasicLink ? (
				<BasicBtn {...props} />
			) : (
				<Complexbtn {...props} />
			)}
		</>
	);
}

const BasicBtn = (props: ResetBtnType) => {
	const { btnClassName, resetSelected } = props;

	const classes: string[] = [];

	const basicStyle = `group relative inline-block transition-colors last:mr-0 w-fit`;

	classes.push(btnClassName?.ClassName ? btnClassName?.ClassName : '', basicStyle, '');

	classes.push(
		`${btnClassName?.ClassName ? btnClassName?.ClassName : ''} ${btnClassName?.btnStyle?.hasUnderline ? ' underline underline-offset-4' : ''}`
	);

	return (
		<button className={classes.join(' ')} onClick={resetSelected}>
			<span>{__Front('front.filters.reset')}</span>
		</button>
	);
};

const Complexbtn = (props: ResetBtnType) => {
	const { btnClassName, resetSelected } = props;
	const classes: string[] = [];

	const basicStyle = `group relative inline-block transition-colors last:mr-0 w-fit`;

	classes.push(btnClassName?.ClassName ? btnClassName?.ClassName : '', basicStyle, '');

	return (
		<>
			<Animation
				animation={btnClassName?.btnStyle?.animation}
				className={`${classes.join(' ')} inline-flex items-center justify-center gap-2`}
				onClick={resetSelected}
				isReset={true}
			>
				<span
					className={`${btnClassName?.btnStyle?.btnHasIcon && btnClassName?.btnStyle?.btnDecorationElement === 'underline' ? 'underline underline-offset-4' : ''}`}
				>
					{__Front('front.filters.reset')}
				</span>

				{btnClassName?.btnStyle?.btnHasIcon && (
					<>
						{btnClassName?.btnStyle?.btnDecorationElement === 'long' && (
							<ArrowLong
								width='20'
								className='transition-transform group-hover:translate-x-2 group-hover:duration-300 group-hover:ease-in-out'
							/>
						)}

						{btnClassName?.btnStyle?.btnDecorationElement === 'short' && (
							<ArrowSmall
								width='20'
								className='transition-transform group-hover:translate-x-2 group-hover:duration-300 group-hover:ease-in-out'
							/>
						)}
					</>
				)}
			</Animation>
		</>
	);
};
